import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { HttpClient } from '@angular/common/http';
import { coerceNumberProperty } from '@angular/cdk/coercion';
import { HttpHeaders, HttpEventType, HttpRequest, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { User } from '../User';
import { AlertService } from '../alert.service';
import { Pipe, PipeTransform } from "@angular/core";
import { DatePipe } from '@angular/common';
import { ModalDirective } from 'angular-bootstrap-md';


@Component({
  selector: 'app-ongoing-booking',
  templateUrl: './ongoing-booking.component.html',
  styleUrls: ['./ongoing-booking.component.scss']
})

export class OngoingBookingComponent implements OnInit {
  @ViewChild('mobileVerifyModal') mobileVerifyModal: ModalDirective;
  @ViewChild('mobileEditModal') mobileEditModal: ModalDirective;
  @ViewChild('OTPModal') OTPModal: ModalDirective;
  @ViewChild('paymentProceedExtend') paymentGatewayProceedExtend: ModalDirective;
  @ViewChild('extendModal') extendModal: ModalDirective;
  @ViewChild('extend0Modal') extend0Modal: ModalDirective;
  finalNumberToShow:number=0;
  showExtend: boolean = true;
  public buttonContent: any = 'Extend Subscription';
  // setting base url for payment surl and furl
  baseUrl: any;
  toggleExtend() {
    this.showExtend = !this.showExtend;
    // CHANGE THE NAME OF THE BUTTON.
    if (this.showExtend)
      this.buttonContent = "Extend Subscription";
    else
      this.buttonContent = "Back";
  }

  private user: User = new User();

  timeSlots: Array<any> = [];
  public ongoingData: any = [];
  public getCompDetail: any = [];
  public serviceRequestData: any = [];
  subscriptionData: any = {}; // to store the value of subscription booking data
  //getServiceRequest


  private debugData: Boolean = true; // to show and hide the data in console log
  otpErrorMsg: string = ""; // to display the error msg on otp popup
  mobileverifyMsg: string = ""; //shows msg mobile verified or not
  todaydate: Date = new Date(); // to show in the service model request and disable date of before

  btnTextShow: string = 'View More';
  btnTextHide: string = 'View Less';
  btnText: string = this.btnTextShow;

  constructor(@Inject(LOCAL_STORAGE) private storage: WebStorageService, private apiService: ApiService,
    private httpClient: HttpClient, private alertService: AlertService, private datePipe: DatePipe) {
    this.initCustData();
    this.baseUrl = 'https://api.on-track.in';
    //this.baseUrl = 'http://159.65.154.92';
    // if (window.location.hostname == 'localhost')
    //   //this.baseUrl='http://127.0.0.1:1337';
    //   this.baseUrl = 'https://api.on-track.in';
    // else
    //   this.baseUrl = window.location.origin;
  }

  ngOnInit() {

  }

  initCustData() {
    if (this.apiService.checkUserLoggedIn() == true) {
      let urrr = this.apiService.cutomerDetails + this.apiService.getFromLocalData('custDD');
      this.httpClient.get(urrr)
        .subscribe(
          data => this.intilizeComponent(data),
          error => this.showError(error)
        );

    } else {
      console.log("User Not Logged In. Please login!")
    }
  }

  intilizeComponent(data) {
    this.user = data;
    this.getOngoing();
    this.getServiceRequest();
    this.getCustomerPoints();
    this.getReferralPoints();
    if (this.user.mobileVerified == 0) {
      this.mobileverifyMsg = "mobile not verified";
    }
    else {
      this.mobileverifyMsg = "mobile verified";
    }
  }

  showError(msg) {
    console.log("Error Found in server");
  }


  refresh(): void {
    window.location.reload();
  }

  //public custdd = this.apiService.getFromLocalData('custDD');
  getOngoing() {
    if (this.debugData) {
      console.log("OnGoing FUnction : ");
    }
    let getData = { "customer": this.user.id }
    this.httpClient.post(this.apiService.ongoingBooking, getData)
      .subscribe(
        (jdetail: any) => {

          if (this.debugData) {
            console.log("OnGoing API Data: ");
            console.log(jdetail);
          }
          this.ongoingData = jdetail;
          if (this.ongoingData.length != 0) {
            this.getDaysLeft(this.ongoingData[0].startDate, this.ongoingData[0].endDate);
            if (this.debugData) {
              console.log("Days left");
              console.log(this.daysLeftValue);
            }
            if (this.ongoingData[0].isSubscription == 1) {
              this.getSubscriptionInfo();
            }
            this.getServiceRequest();
            if (this.daysLeftValue < 0) {
              this.changeDays(Math.abs(this.daysLeftValue));
            } else {
              this.changeDays(Math.abs(this.daysLeftValue));
            }
          }
        }
      )
  }

  isEmptyObject(obj) {
    return (obj && (Object.keys(obj).length === 0));
  }


  autoTicks = false;
  disabled = false;
  invert = false;
  showTicks = false;

  get tickInterval(): number | 'auto' {
    return this.showTicks ? (this.autoTicks ? 'auto' : this._tickInterval) : 0;
  }
  set tickInterval(value) {
    this._tickInterval = coerceNumberProperty(value);
  }
  private _tickInterval = 1;




  getServiceRequest() {
    //GET_SERVICE_BY_CUSTOMER
    if (this.debugData) {
      console.log("Service Request Function");
    }
    this.httpClient.get(this.apiService.GET_SERVICE_BY_CUSTOMER + this.user.id)
      .subscribe(
        data => this.showServiceRequestData(data),
        error => this.showErrorService(error)
      );
  }

  showServiceRequestData(serviceData) {
    if (this.debugData) {
      console.log("Service Requesr API data");
      console.log(serviceData);
    }
    this.serviceRequestData = serviceData;

    // agentId: null // agentName: null // createdAt: "2018-10-24T11:12:09.000Z"
    // customer: 6840 // customerName: "nav" // date: "2018-10-27T00:00:00.000Z"
    // endTime: "02:00:00" // id: 38 // modelName: "TVS Sport" // serviceId: "S18G0038"
    // startTime: "12:00:00" // status: 0 // timeslotid: 2 // vehicleId: 599
    // vehicleNumber: "KA 03 AF 4702"
  }

  showErrorService(errorData) {
    if (this.debugData) {
      console.log("Service Requesr API error data");
      console.log(errorData);
    }
  }

  getTimeSlot(dateSlot) {
    let dateToSearch = "";
    if ((typeof dateSlot === 'string') && (dateSlot.indexOf('/') > -1)) {
      const str = dateSlot.split('/');
      const year = Number(str[2]);
      const date = Number(str[1]);
      const month = Number(str[0]);
      dateToSearch = year + "-" + month + "-" + date;
    }

    if ((dateToSearch != null) || (dateToSearch != "")) {
      let dateData = { date: dateToSearch }
      if (this.debugData) {
        console.log("get time slot function data");
        console.log(dateData);
      }
      this.httpClient.post(this.apiService.GET_SERVICE_REQUEST_TIME, dateData)
        .subscribe(
          (timeSlot: any) => {
            if (this.debugData) {
              console.log("get Time Slot API Data");
              console.log(timeSlot);
            }
            this.timeSlots = timeSlot;
          }
        )
    } else {
      if (this.debugData) {
        console.log("Some Error occured while getting slot, Please try again");
      }
    }
  }

  // ServiceErrorMsg: string = "";
  // createService(dateSelectect, timeSlotId) {
  //   //console.log("create service date and id");
  //   //console.log(dateSelectect);
  //   //console.log(timeSlotId);
  //   let requestServiceData = {};

  //   if ((timeSlotId == undefined) || (timeSlotId == null) || (timeSlotId == '') ||
  //     (dateSelectect == undefined) || (dateSelectect == null) || (dateSelectect == '')) {
  //     this.ServiceErrorMsg = "Please choose correct Date and Time";
  //   } else {
  //     let dateOfServicing = "";
  //     if ((typeof dateSelectect === 'string') && (dateSelectect.indexOf('/') > -1)) {
  //       const str = dateSelectect.split('/');
  //       const year = Number(str[2]);
  //       const date = Number(str[1]);
  //       const month = Number(str[0]);
  //       dateOfServicing = year + "-" + month + "-" + date;
  //     }

  //     for (let i = 0; i < this.timeSlots.length; i++) {
  //       if (this.timeSlots[i].id == timeSlotId) {
  //         requestServiceData = {
  //           "vehicleId": this.ongoingData[0].vehicle,
  //           "customer": this.user.id,
  //           "date": dateOfServicing,
  //           "startTime": this.timeSlots[i].startTime + ":00:00",
  //           "endTime": this.timeSlots[i].endTime + ":00:00",
  //           "model": this.ongoingData[0].model,
  //           "timeSlotId": timeSlotId
  //         }
  //         break;
  //       }
  //     }

  //     //console.log("Servicing data is");
  //     //console.log(requestServiceData);

  //     this.httpClient.post(this.apiService.CREATE_SERVICE_REQUEST, requestServiceData)
  //       .subscribe(
  //         (serviceData: any) => {
  //           if (this.debugData) {
  //             console.log("get Time Slot API Data");
  //             console.log(serviceData);
  //           }
  //           if (serviceData.status == true) {
  //             this.ServiceErrorMsg = "Service request already";
  //             this.getServiceRequest();
  //           } else {
  //             this.ServiceErrorMsg = "Service request raised already";
  //           }
  //           //this.timeSlots = timeSlot;
  //           //{ status: true, message: "created" }
  //         }
  //       )

  //     // CREATE_SERVICE_REQUEST
  //   }

  //   // available: 7
  //   // endTime: 6
  //   // id: 4
  //   // label: "4 PM - 6 PM"
  //   // startTime: 4

  //   //{ "vehicleId": 599, "customer": 6840, "date": "2018-10-27", 
  //   //"startTime": "12:00", "endTime": "2:00", "model": 19, "timeSlotId": 2 }
  // }

  ServiceErrorMsg: string = "";
  createService(qurr) {
    
    //console.log("create service date and id");
    //console.log(dateSelectect);
    //console.log(timeSlotId);
    let requestServiceData = {};

    // if ((timeSlotId == undefined) || (timeSlotId == null) || (timeSlotId == '') ||
    //   (dateSelectect == undefined) || (dateSelectect == null) || (dateSelectect == '')) {
    //   this.ServiceErrorMsg = "Please choose correct Date and Time";
    // } else {
    //   let dateOfServicing = "";
    //   if ((typeof dateSelectect === 'string') && (dateSelectect.indexOf('/') > -1)) {
    //     const str = dateSelectect.split('/');
    //     const year = Number(str[2]);
    //     const date = Number(str[1]);
    //     const month = Number(str[0]);
    //     dateOfServicing = year + "-" + month + "-" + date;
    //   }

    //   for (let i = 0; i < this.timeSlots.length; i++) {
    //     if (this.timeSlots[i].id == timeSlotId) {
    //       requestServiceData = {
    //         "vehicleId": this.ongoingData[0].vehicle,
    //         "customer": this.user.id,
    //         "date": dateOfServicing,
    //         "model": this.ongoingData[0].model,
    //         "timeSlotId": timeSlotId
    //       }
    //       break;
    //     }
    //   }

      //console.log("Servicing data is");
      //console.log(requestServiceData);

      requestServiceData = {
                 "vehicleId": this.ongoingData[0].vehicle,
                 "customer": this.user.id,
                 "model": this.ongoingData[0].model,
                 "customerQuery":qurr
        //         "date": dateOfServicing,
        //         "model": this.ongoingData[0].model,
        //         "timeSlotId": timeSlotId
               }
               console.log(requestServiceData);
      this.httpClient.post(this.apiService.CREATE_SERVICE_REQUEST, requestServiceData)
        .subscribe(
          (serviceData: any) => {
            if (this.debugData) {
              console.log("get Time Slot API Data");
              console.log(serviceData);
            }
            if (serviceData.status == true) {
              this.ServiceErrorMsg = "Our execution will get in touch with you within 24 hours to help you out.";
              this.getServiceRequest();
              //this.requestModalService.hide();
            } else {
              this.ServiceErrorMsg = "Service request raised already";
            }
            //this.timeSlots = timeSlot;
            //{ status: true, message: "created" }
          }
        )

      // CREATE_SERVICE_REQUEST
   // }

    // available: 7
    // endTime: 6
    // id: 4
    // label: "4 PM - 6 PM"
    // startTime: 4

    //{ "vehicleId": 599, "customer": 6840, "date": "2018-10-27", 
    //"startTime": "12:00", "endTime": "2:00", "model": 19, "timeSlotId": 2 }
  }

  //////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////Start of extend payment //////////////////////////////////

  availablePoints: number = 0; // to display and hold available points
  helMetPriceUi: number = 0; // to display the price of rental helmet charge in ui
  monthlyRentalChargeUi: number = 0; // to display the price of rental helmet charge in ui
  noOfDaysUI: number = 0; // to display the noOfDays of rent in ui
  newEndDateUi: string = "";
  totalPriceToPayUi: number = 0;
  finalAmount: number = 0; //final Amount which willl go to the payment gateway after having everything
  penalityChargeUi: number = 0;

  usePoints: boolean = false; // to get to know customer is using the points or not

  changeDays(noOfDay) {
    this.availablePoints = this.points;
    this.noOfDaysUI = noOfDay;
    this.penalityChargeUi = this.user.penaltyCharge;
    let tempArray: Array<any> = this.ongoingData[0].endDate.split('T');
    let StartDateObj = new Date(tempArray[0]);
    StartDateObj.setDate(StartDateObj.getDate() + noOfDay);
    this.newEndDateUi = this.datePipe.transform(StartDateObj, 'dd/MM/yyyy');

    let helmentChargeValue = 0;
    let DaysHelmetCharge = 0;
    let DaysRentalCharge = 0;
    let DayTotalPrice = 0;
    let modelPriceValue = this.ongoingData[0].rentalCharge;

    if (this.ongoingData[0].extraHelmet == true) {
      helmentChargeValue = 50;
    }
    else {
      helmentChargeValue = 0;
    }

    if (noOfDay <= 7) {
      DaysRentalCharge = ((modelPriceValue) + ((modelPriceValue * 20) / 100));
      DaysRentalCharge = ((DaysRentalCharge / 30) * noOfDay);

      DaysHelmetCharge = ((helmentChargeValue) + ((helmentChargeValue * 20) / 100));
      DaysHelmetCharge = ((DaysHelmetCharge / 30) * noOfDay);
    } else if (noOfDay >= 8 && noOfDay < 16) {
      DaysRentalCharge = ((modelPriceValue) + ((modelPriceValue * 15) / 100));
      DaysRentalCharge = ((DaysRentalCharge / 30) * noOfDay);

      DaysHelmetCharge = ((helmentChargeValue) + ((helmentChargeValue * 15) / 100));
      DaysHelmetCharge = ((DaysHelmetCharge / 30) * noOfDay);
    } else if (noOfDay >= 16) {
      DaysRentalCharge = ((modelPriceValue) + ((modelPriceValue * 10) / 100));
      DaysRentalCharge = ((DaysRentalCharge / 30) * noOfDay);

      DaysHelmetCharge = ((helmentChargeValue) + ((helmentChargeValue * 10) / 100));
      DaysHelmetCharge = ((DaysHelmetCharge / 30) * noOfDay);
    }

    DayTotalPrice = Number(DaysRentalCharge.toFixed(2)) + Number(DaysHelmetCharge.toFixed(2));
    this.helMetPriceUi = Number(DaysHelmetCharge.toFixed(2));
    this.monthlyRentalChargeUi = Number(DaysRentalCharge.toFixed(2));
    this.totalPriceToPayUi = Number(DayTotalPrice.toFixed(2));

    if (DaysRentalCharge >= modelPriceValue) {
      DaysRentalCharge = modelPriceValue;
      this.monthlyRentalChargeUi = DaysRentalCharge;
    }

    if (DaysHelmetCharge >= helmentChargeValue) {
      DaysHelmetCharge = helmentChargeValue;
      this.helMetPriceUi = DaysHelmetCharge;
    }

    if (DayTotalPrice >= (modelPriceValue + helmentChargeValue)) {
      DayTotalPrice = modelPriceValue + helmentChargeValue;
      this.totalPriceToPayUi = DayTotalPrice
      console.log("day price");
      console.log(this.totalPriceToPayUi);
    }

    if (this.user.penaltyCharge != 0) {
      this.totalPriceToPayUi += this.user.penaltyCharge;
    }


    if (this.usePoints == true) {
      this.finalAmount = this.totalPriceToPayUi - this.availablePoints;
      if (this.finalAmount < 1) {
        this.finalAmount = 0;
      }
    } else {
      this.finalAmount = this.totalPriceToPayUi;
    }
    // console.log("Total price");
    // console.log(DayTotalPrice);
    // console.log(DaysRentalCharge);
    // console.log(DaysHelmetCharge);
    if(this.availablePoints > this.totalPriceToPayUi)
    {
      this.finalNumberToShow=this.totalPriceToPayUi;
      console.log(this.finalNumberToShow);

    }
    else{
      this.finalNumberToShow=this.availablePoints;
      console.log(this.finalNumberToShow);
        }
  }

  onGoingSubscriptionId: string = "";
  intiateExtendBooking(transactionType) {
    // transaction type tells about the booking type so if transcationType = 0 then it is normal booking 
    // else it is subscription type
    let extendBookingObj = {};
    let productInfoObj = {};
    let udfObj = {};
    //let TotalPrice = 0;

    if (this.ongoingData[0].isSubscription == 1) {
      // payment is subscription type
      if ((this.usePoints == true) && (this.availablePoints != 0)) {
        udfObj = {
          udf1: 'points',
          udf2: 30,
          udf3: this.ongoingData[0].rentalCharge < 1 ? this.totalPriceToPayUi : this.availablePoints,
          udf4: this.ongoingData[0].bookingId,
          udf5: this.ongoingData[0].endDate
        };
      } else {
        udfObj = {
          udf1: 'normal',
          udf2: 30,
          udf3: 0,
          udf4: this.ongoingData[0].bookingId,
          udf5: this.ongoingData[0].endDate
        };
      }

      let extraChargesPenalityHelmet: number = 0;
      if (this.ongoingData[0].extraHelmet == true) {
        extraChargesPenalityHelmet += 50;
      }

      if (this.ongoingData[0].penaltyCharge != 0) {
        extraChargesPenalityHelmet += this.user.penaltyCharge
      }

      this.helMetPriceUi = this.ongoingData[0].helmetCharge;
      this.monthlyRentalChargeUi = this.ongoingData[0].rentalCharge;
      this.totalPriceToPayUi = this.helMetPriceUi + this.monthlyRentalChargeUi;
      this.finalAmount = this.totalPriceToPayUi + this.user.penaltyCharge;

      extendBookingObj = {
        customer: this.user.id,
        model: this.ongoingData[0].model,
        bookingId: this.ongoingData[0].bookingId,
        penaltyCharge: this.user.penaltyCharge,
        amount: this.ongoingData[0].rentalCharge + extraChargesPenalityHelmet
      }
      productInfoObj = {
        bookingObj: extendBookingObj,
        subscriptionId: this.subscriptionData.id,
        productInfo: 'extend Subscription ' + this.ongoingData[0].modelName,
        udf: udfObj,
        rentalCharge: this.ongoingData[0].rentalCharge,
        helmetCharge: this.ongoingData[0].helmetCharge
      }

    } else {
      // if payment is normal type
      if ((this.usePoints == true) && (this.availablePoints != 0)) {
        udfObj = {
          udf1: 'points',
          udf2: this.noOfDaysUI,
          udf3: this.finalAmount < 1 ? this.totalPriceToPayUi : this.availablePoints,
          udf4: this.ongoingData[0].bookingId,
          udf5: this.ongoingData[0].endDate
        };
      } else {
        udfObj = {
          udf1: 'normal',
          udf2: this.noOfDaysUI,
          udf3: 0,
          udf4: this.ongoingData[0].bookingId,
          udf5: this.ongoingData[0].endDate
        };
      }
      extendBookingObj = {
        customer: this.user.id,
        model: this.ongoingData[0].model,
        bookingId: this.ongoingData[0].bookingId,
        penaltyCharge: this.user.penaltyCharge,
        amount: this.finalAmount,
        source: "web"
      }
      productInfoObj = {
        bookingObj: extendBookingObj,
        productInfo: 'extend ' + this.ongoingData[0].modelName,
        udf: udfObj,
        rentalCharge: this.monthlyRentalChargeUi,
        helmetCharge: this.helMetPriceUi
      }
    }
    console.log(productInfoObj);
    this.gotoPaymentGatewayForExtendBooking(productInfoObj);
  }

  paymentGatewayData: any = {}; // whole data object to be sent to the payment gateway server
  gotoPaymentGatewayForExtendBooking(objectToPost) {
    this.httpClient.post(this.apiService.EXTEND_BOOKING_API, objectToPost)
      .subscribe(
        (paymentData: any) => {
          if (this.debugData) {
            console.log("Initiate Payment API Data");
            console.log(paymentData);
          }
          if (paymentData.status == 1) {
            this.paymentGatewayData = paymentData.obj;
            this.paymentGatewayData.service_provider = "";

            this.paymentGatewayData.surl = this.baseUrl + "/api/extendPaymentResponse";
            this.paymentGatewayData.furl = this.baseUrl + "/api/extendPaymentResponse";

            if (this.debugData) {
              console.log("payment gateway object");
              console.log(this.paymentGatewayData);
            }
            //his.paymentGatewayProceedExtend.show();

            if (this.paymentGatewayData.amount == 0) {
              if (this.debugData) {
                console.log("you are elizible for free booking");
              }
              this.goToDirectBookingGateway(this.paymentGatewayData);
              //this.paymentGatewayProceedExtend.show();
            } else {
              this.paymentGatewayProceedExtend.show();
            }
          } else {
            this.error("Some Error Occured, Try again after some time.");
            console.log("Some Error Occured, You have ongoing booking ");
          }
        },
        (err) => {
          if (this.debugData) {
            console.log("Some error occured while parsing data from url");
          }
        });
  }

  ////////////////////////////End of extend payment //////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////
 /**
   * Direct payment method
   */

  goToDirectBookingGateway(PamentObject) {

    let txnIdMiphid = Math.round((new Date()).getTime() / 1000);
    let jsonDataPayment = {
      status: 'success',
      mihpayid: txnIdMiphid,
      txnid: PamentObject.txnid,
      udf1: PamentObject.udf1,
      udf2: PamentObject.udf2,
      udf3: PamentObject.udf3,
      udf4: PamentObject.udf4,
      udf5: PamentObject.udf5,
      amount: PamentObject.amount
    }
  console.log(jsonDataPayment);
    this.httpClient.post(this.apiService.extendPaymentResponseURL, jsonDataPayment)
        .subscribe(
          (extendResponse: any) => {
            if (this.debugData) {
              console.log("extend pay response");
              console.log(extendResponse);
            }
            if (extendResponse.status = 1) {
              console.log(extendResponse.paymentId);
              this.extendModal.hide();
              this.extend0Modal.show();
            }
            
          }
        )


  }

  daysLeftValue: number = 0;
  daysSliderMin: number = 0;
  getDaysLeft(startDate, endDate) {
    let dateTodayNow = new Date();
    let tempArray: Array<any> = startDate.split('T');
    let StartDateObj = new Date(tempArray[0]);
    let tempArray2: Array<any> = endDate.split('T');
    let EndDateObj = new Date(tempArray2[0]);

    if (dateTodayNow.valueOf() < StartDateObj.valueOf()) {
      let timeTemp = EndDateObj.getTime() - StartDateObj.getTime();
      this.daysLeftValue = Math.round(Math.abs(timeTemp / (1000 * 60 * 60 * 24)));
    } else {
      if ((dateTodayNow.valueOf() >= StartDateObj.valueOf()) && (dateTodayNow.valueOf() <= EndDateObj.valueOf())) {
        let timeTemp = EndDateObj.getTime() - dateTodayNow.getTime();
        this.daysLeftValue = Math.round(Math.abs(timeTemp / (1000 * 60 * 60 * 24)));
        this.daysSliderMin = 0;
      } else {
        let timeTemp = dateTodayNow.getTime() - EndDateObj.getTime();
        this.daysLeftValue = -(Math.round(Math.abs(timeTemp / (1000 * 60 * 60 * 24))));
        this.daysSliderMin = (Math.round(Math.abs(timeTemp / (1000 * 60 * 60 * 24))));
      }
      //var time = new Date().getTime() - new Date("2013-02-20T12:01:04.753Z").getTime();
    }
  }

  getDateOfBookingString(dateToGet) {
    if (dateToGet) {
      let tempArray: Array<any> = dateToGet.split('T');
      let myDateG = new Date(tempArray[0]);
      return this.datePipe.transform(myDateG, 'dd/MM/yyyy');
    } else {
      return 'N/A'
    }
  }


  getCustomerPoints() {
    let dataToPost = { id: this.user.id }
    this.httpClient.post(this.apiService.getCustomerPoints, dataToPost)
      .subscribe(
        (dataPoint: any) => {
          if (this.debugData) {
            console.log("Customer get Point API data");
            console.log(dataPoint);
          }
          this.availablePoints = dataPoint.points;
          //availablePoints
        },
        (err) => {
          if (this.debugData) {
            console.log("Some error occured while parsing data from url");
          }
        });
  }

  applyPoints(val) {
    this.usePoints = val.checked;
    if (this.usePoints == true) {
      this.finalAmount = this.finalAmount - this.availablePoints;
      if (this.finalAmount < 1) {
        this.finalAmount = 0;
      }
    } else {
      this.finalAmount = this.totalPriceToPayUi;
      console.log("final amt");
      console.log(this.finalAmount);
    }
    console.log(this.usePoints);
  }


  currentSubscribedMonth: number = 0;
  getSubscriptionInfo() {
    //console.log("Inside subscription info");
    ///getSubscriptionInfo
    //console.log(this.ongoingData[0].id)
    let dataToSend = {
      bookingId: Number(this.ongoingData[0].id),
      status: 1
    }
    this.httpClient.post(this.apiService.GET_SUBSCRIPTION_INFO, dataToSend)
      .subscribe(
        (subData: any) => {
          if (this.debugData) {
            console.log("Subscription Data get Point API data");
            console.log(subData);
          }
          this.subscriptionData = subData;
          this.currentSubscribedMonth = this.subscriptionData.totalMonths;
        },
        (err) => {
          console.log(err);
          if (this.debugData) {
            console.log("Some error occured while parsing data from url");
          }
        });
    //console.log(this.usePoints);
  }

  updateSubscriptionBtnMsg: string = "";
  subscriptionChangeErrorMsg: string = "";
  updateSubscriptionPlan() {
    console.log("extndedMonth");
    //console.log(this.selectedMonthToExtend);
    let dataToSubs = {
      "totalMonths": Number(this.selectedMonthToExtend),
      "selectedMonths": this.subscriptionData.selectedMonths,
      "extendedMonths": Number(this.selectedMonthToExtend),
      "completedMonths": this.subscriptionData.completedMonths
    }

    if ((Number(this.selectedMonthToExtend) > 0) && (this.currentSubscribedMonth < this.selectedMonthToExtend)) {
      console.log("You are right");
      this.updateSubscriptionBtnMsg = "Updating your plan";
      this.httpClient.post(this.apiService.EXTEND_SUBSCRIPTION_MONTH + this.subscriptionData.id, dataToSubs)
        .subscribe(
          (subData: any) => {
            if (this.debugData) {
              console.log("Subscription Data get Point API data");
              console.log(subData);
            }
            this.subscriptionData = subData;
            this.updateSubscriptionBtnMsg = "Sucessfully updated";
          },
          (err) => {
            console.log(err);
            if (this.debugData) {
              console.log("Some error occured while parsing data from url");
              this.updateSubscriptionBtnMsg = "Some error occured. Please try again";
            }
          });
    } else {
      this.updateSubscriptionBtnMsg = "Please choose valid month";
      this.subscriptionChangeErrorMsg = "Please choose valid month";
    }
    console.log(dataToSubs);
  }

  selectedMonthToExtend: number = 0;
  updateMonthSubscription(monthsToExtend) {
    this.selectedMonthToExtend = monthsToExtend;
    if (this.debugData) {
      console.log("Month Clicked");
      console.log(monthsToExtend);
    }
  }

  disableOrEnableButton(val: number): boolean {
    if (val <= this.currentSubscribedMonth) {
      return true;
    }
  }
  selectedMonthsVal: number = 0; // tp show the selected month in ui from previous page
  /*normal booking to subscription booking */
  // function to fetch and show the plan data from server in each click of plan.
  initModelData(months: number) {
    this.selectedMonthsVal = months;
    if (this.debugData == true) {
      console.log("Months Selected");
      console.log(this.selectedMonthsVal);
    }

  }
  userSubMsg: string = "";
  updateNormalToSub() {
    let isSubscriptionChoosed: number = 0;
    // if subscrption choosed
    if (this.selectedMonthsVal == 1) {
      isSubscriptionChoosed = 0;
    } else {
      isSubscriptionChoosed = 1;
    }
    let sub_booking_id = this.apiService.normal_subscription_URL + this.ongoingData[0].id;
    console.log(sub_booking_id);
    let subsData = { "isSubscription": isSubscriptionChoosed };
    this.httpClient.post(sub_booking_id, subsData)
      .subscribe(
        (nor_sub_detail: any) => {
          if (this.debugData) {
            console.log("update sub data")
            console.log(nor_sub_detail)
          }
          // this.uerDlUpdateMsg = "DL updated Sucess";
          this.user = nor_sub_detail;
          console.log(this.user);

          console.log(this.subscriptionData.totalMonths);
          let nor_sub_data = {
            "bookingId": this.ongoingData[0].id,
            "totalMonths": this.selectedMonthsVal,
            "selectedMonths": this.selectedMonthsVal,
            "extendedMonths": Number(this.selectedMonthToExtend),
            "completedMonths": 0,
            "status": 1
          }
          console.log(nor_sub_data);
          this.httpClient.post(this.apiService.subscription_URL, nor_sub_data)
            .subscribe(
              (subSr_data: any) => {

                if (this.debugData) {
                  console.log("subscribed success");
                  console.log(subSr_data);
                }
                this.initCustData();
                this.user = subSr_data;
                //this.getSubscriptionInfo();
              }
            )
        },
        (err) => {
          this.userSubMsg = "Some error occured. Please try again";
        });
  }

  /*end normal to subscription booking */

  public points: number;
  getReferralPoints() {
    let getRefpoint = { "id": this.user.id }
    this.httpClient.post(this.apiService.referralURL, getRefpoint)
      .subscribe(
        (refdetail: any) => {
          if (this.debugData) {
            console.log("Referral API Data");
            console.log(refdetail);
          }
          this.points = refdetail.points;
        }
      )
  }
  success(message: string) {
    this.alertService.success(message);
  }

  error(message: string) {
    this.alertService.error(message);
  }

  info(message: string) {
    this.alertService.info(message);
  }

  warn(message: string) {
    this.alertService.warn(message);
  }

  clear() {
    this.alertService.clear();
  }
}




// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/ongoing-booking/ongoing-booking.component.ts